<div class="spinner-grow" role="status">
    <span class="visually-hidden" i18n="Loading spinner">Loading...</span>
</div>
